import './tabs';

import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/offcanvas';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/tab';

import './formPopup';

import './swiper';
import './video-popup'
import './form';
import './case-study-popup';


let currentYPosition;
const logoSubtitle = document.querySelector('.header__logo-subtitle');
const uno = document.querySelector('.header__logo-link');
const dos = document.querySelector('.header__logo-text');
document.addEventListener('scroll', () => {
    currentYPosition = window.scrollY;

    if(currentYPosition >= 22) {
        uno.classList.add('visible')
        dos.classList.add('visible')
        logoSubtitle.classList.add('visible')
    } else {
        uno.classList.remove('visible')
        dos.classList.remove('visible')
        logoSubtitle.classList.remove('visible')
    }
})